/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
export default {
  getBoutiques (state) {
    let boutiques = state.boutiques.filter((boutique) => {
      return boutique.is_boutique === '1'
    })
    return boutiques
  },
  getAllStores (state) {
    return state.boutiques
  },
  getBoutique (state) {
    return state.boutique
  },
  getCorners (state) {
    let corners = state.boutiques.filter((boutique) => {
      return boutique.is_boutique !== '1'
    })
    return corners
  },
  getActiveBoutique (state) {
    return state.activeBoutique
  },
  getOpenFindInBoutique (state) {
    return state.openFindInBoutiue
  },
  getStoresByProduct (state) {
    return state.storesByProduct
  }
}
